module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/blog/five-trends-shaping/five-trends-shaping.component.scss
// module id = 759
// module chunks = 0